var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockblack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17136",
    "data-name": "Rectangle 17136",
    d: "M0,0H19A10,10,0,0,1,29,10V20A10,10,0,0,1,19,30H10A10,10,0,0,1,0,20V0A0,0,0,0,1,0,0Z",
    transform: "translate(347.013 285.763)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-347.013 -285.763)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lock",
    d: "M4.668,11.2V8.4a8.4,8.4,0,0,1,16.806,0v2.8h.934a3.738,3.738,0,0,1,3.735,3.735v11.2a3.738,3.738,0,0,1-3.735,3.735H3.735A3.736,3.736,0,0,1,0,26.143v-11.2A3.736,3.736,0,0,1,3.735,11.2Zm3.735,0H17.74V8.4A4.668,4.668,0,1,0,8.4,8.4Z",
    transform: "translate(348.442 285.824)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockblack);
export default __webpack_public_path__ + "static/media/lock black.06921eb2b942d603318f731b7b7d7043.svg";
export { ForwardRef as ReactComponent };